export { default } from './HidePriceMessage'
